var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSearchCountry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow-forward") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop_7",
    transform: "translate(-828.000000, -784.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy",
    transform: "translate(580.000000, 664.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10-Copy-2",
    transform: "translate(0.000000, 108.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-forward",
    transform: "translate(248.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#000000",
    opacity: 0,
    transform: "translate(8.000000, 8.000000) rotate(-90.000000) translate(-8.000000, -8.000000) ",
    points: "-6.1284311e-14 -6.02051984e-14 16 -6.02051984e-14 16 16 -6.1284311e-14 16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33333333,8.66666667 L11.24,8.66666667 L8.82,11.5733333 C8.58435851,11.8568395 8.6231605,12.2776918 8.90666667,12.5133333 C9.19017284,12.7489748 9.61102517,12.7101728 9.84666667,12.4266667 L13.18,8.42666667 C13.2024262,8.39485045 13.2224804,8.36142684 13.24,8.32666667 C13.24,8.29333333 13.2733333,8.27333333 13.2866667,8.24 C13.3168843,8.16356088 13.3327059,8.08219278 13.3333333,8 C13.3327059,7.91780722 13.3168843,7.83643912 13.2866667,7.76 C13.2866667,7.72666667 13.2533333,7.70666667 13.24,7.67333333 C13.2224804,7.63857316 13.2024262,7.60514955 13.18,7.57333333 L9.84666667,3.57333333 C9.71976234,3.42097327 9.53162149,3.33301131 9.33333333,3.33333206 C9.17756523,3.33302899 9.02660804,3.38727923 8.90666667,3.48666667 C8.77032858,3.59969878 8.68456811,3.76233385 8.66830872,3.93868567 C8.65204933,4.11503749 8.7066274,4.29061159 8.82,4.42666667 L11.24,7.33333206 L3.33333333,7.33333206 C2.9651435,7.33333206 2.66666667,7.63181017 2.66666667,8 C2.66666667,8.36818983 2.9651435,8.66666667 3.33333333,8.66666667 Z",
    id: "Path",
    fill: "#1D2B7D"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSearchCountry);
export default __webpack_public_path__ + "static/media/Arrow_searchCountry.6ce89294a07e19a8dd87af19e4c89bd3.svg";
export { ForwardRef as ReactComponent };